import { render, staticRenderFns } from "./withoutHeader.vue?vue&type=template&id=0012a6ac&"
import script from "./withoutHeader.vue?vue&type=script&lang=js&"
export * from "./withoutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports